import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { forkJoin } from 'rxjs';
import { UserService } from '../../../auth/services/user.service';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { CustomerType } from '../../models/enums/customer-type.enum';
import { CustomerManageService } from '../../shared/customer-manage.service';

export class CustomerDetailModalContext {
    constructor(public customerNumberId: number, public isIndividual: boolean = true) {}
}

@Component({
    selector: 'customer-detail-modal',
    templateUrl: './customer-details-modal.html'
})
export class CustomerDetailModalComponent extends BaseComponent {
    public customerType = 0;
    public customerNumberId = 0;
    public customerTypes = new CustomerType();

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<CustomerDetailModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CustomerDetailModalContext,
        public customerService: CustomerManageService,
        public userService: UserService
    ) {
        super();

        this.customerNumberId = data.customerNumberId;
        forkJoin({
            cusomterType: this.customerService.getCustomerType(this.customerNumberId),
            customerUserAgentCustomerNumbers: this.userService.getCustomerUserAgentCustomerNumbers()
        }).subscribe(
            result => {
                if (result.customerUserAgentCustomerNumbers.includes(this.customerNumberId)) {
                    this.handleValidationResult(this.userService.createAccessToUserDeniedValidationError());
                } else {
                    this.customerType = result.cusomterType;
                }
            },
            error => {}
        );

        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    ngOnInit() {
    }

    /**
     * Cancel and close modal.
     */
    cancel() {
        this.dialogRef.close();
    }
}
